export default "__VITE_ASSET__56e15795__"